import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import userService from "../../Services/UserService";
import teamService from "../../Services/TeamService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import Loader from "../../Constant/Loader";
import AsteriskStyle from "../../Form/Tooltip/AsteriskStyle";
import CustomHeading from "../../common/CustomHeading";
const UserCreation = () => {
  const [name, setName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [role, setRole] = useState("");
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [errors, setErrors] = useState({});
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [loading, setLoading] = useState(false);


  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;

  const handlePhoneNumberChange = (e) => {
    const newPhoneNumber = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPhoneNumber(newPhoneNumber.slice(0, 10)); // Limit to 10 digits
    setPhoneNumberError(
      newPhoneNumber.length !== 10 || /\D/.test(newPhoneNumber)
    );
    setErrors((prevErrors) => ({ ...prevErrors, phoneNumber: "" }));
  };

  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!emailId.trim()) newErrors.emailId = "Email ID is required";
    if (!employeeId) newErrors.employeeId = "Employee ID is required";
    if (!phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    }
    if (!role) newErrors.role = "Role is required";
    if (role == "Admin" || role == "Lead Uploader" ) {
      if (selectedTeam.length === 0)
        newErrors.selectedTeam = "Team is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const fetchTeamData = async () => {
      try {
        const response = await teamService.fetchTeams();
        const teamData = response.data.map((item) => ({
          value: item.teamId,
          label: item.name,
          hasMD: item.MD,
        }));
        setTeams(teamData);
      } catch (error) {
        showErrorToast(error.response.data)

        console.error("Error fetching Teams:", error);
      }
    };
    fetchTeamData();
  }, []);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneRegex = /^[0-9]{10}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (!emailRegex.test(emailId)) {
      setEmailError("Invalid email format");
      showErrorToast("Invalid email format");
      return;
    }

    if (!phoneRegex.test(phoneNumber)) {
      setPhoneError("Invalid phone number format");
      showErrorToast("Invalid phone number format");
      return;
    }
    setLoading(true);
    try {
      // Validate email
      const emailResponse = await userService.validateEmailId(emailId);
      if (emailResponse.data.duplicate) {
        setEmailError("Email ID already exists");
        showErrorToast("Email ID already exists");
        setLoading(false);
        return;
      } else {
        setEmailError("");
      }

      // Validate phone number
      const phoneNumberInt = parseInt(phoneNumber);
      const phoneResponse = await userService.validatePhoneNumber(
        phoneNumberInt
      );
      if (phoneResponse.data.duplicate) {
        setPhoneError("Phone number already exists");
        showErrorToast("Phone number already exists");
        setLoading(false);
        return;
      } else {
        setPhoneError("");
      }

      let userData = {
        emailId,
        employeeId,
        name,
        phoneNumber: parseInt(phoneNumber),
        role,
      };

      if (role != "ADMIN" || role != "CMO") {
        if (Array.isArray(selectedTeam)) {
          userData = {
            team: selectedTeam.map((item) => item.value),
            emailId,
            employeeId,
            name,
            phoneNumber: parseInt(phoneNumber),
            role,
          };
        } else {
          userData = {
            team: [selectedTeam.value != null ? selectedTeam.value : null],
            emailId,
            employeeId,
            name,
            phoneNumber: parseInt(phoneNumber),
            role,
          };
        }
      }

      await userService.createUser(userData);
      if(userRole === "Admin"){

        navigate("/admin/users", {
          state: { message: "User Created Successfully" },
        });
      }else if(userRole === "CMO"){

        navigate("/cmo/users", {
          state: { message: "User Created Successfully" },
        });
      }
      showSuccessToast("User Created Successfully");
    } catch (error) {
      showErrorToast(error.response.data)

      console.error("There was an error adding the user:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleBack = () => {
    if(userRole === "Admin"){

      navigate("/admin/users");
    }else if (userRole === "CMO") {
      navigate("/cmo/users");

    }
  };

  return (
    <div className="bg-appGrayBackground h-screen">
      {loading ? <Loader/> :""}
      <AdminAppBar />
      <ToastContainer />

      <div className="bg-appGrayBackground mt-20 pt-4 px-6 flex flex-col">
        <div className="flex justify-between">
              
        <CustomHeading title={`Creating New User`} isIcon={true}/> 
      

        {/* <div className=""> */}
          <div className="">

            <button
              onClick={handleSubmit}
              className="bg-customGreen text-white md:w-28 md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl lg:text-2xl font-medium"
              disabled={loading}
            >
              {/* {loading ? (
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white"></div>
                </div>
              ) : (
                "Create User"
              )} */}
              Create User
            </button>
          </div>
        </div>
        {/* </div> */}

          <form className="bg-white shadow-md 3xl:w-12/12 3xl:ml-12 rounded md:px-4 lg:px-8 md:pt-6 lg:pt-7 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4 lg:w-full md:w-full">
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="name"
              >
                User Name <AsteriskStyle/>
              </label>
              <input
                className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.name && "border-red-500"
                }`}
                id="name"
                type="text"
                placeholder={errors.name || "Enter User Name"}
                maxLength={40}
                required
                value={name}
                onChange={(e) => {
                  setName(
                    e.target.value.charAt(0).toUpperCase() +
                      e.target.value.slice(1)
                  );
                  setErrors((prevErrors) => ({ ...prevErrors, name: "" }));
                }}
                // onChange={(e) => {
                //   const newValue = e.target.value.replace(/\d/g, '');
                //   const formattedValue = newValue.charAt(0).toUpperCase() + newValue.slice(1);
                //   setName(formattedValue);
                //   setErrors((prevErrors) => ({ ...prevErrors, name: "" }));
                // }}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="role"
              >
                Role <AsteriskStyle/>
              </label>
              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.role && "border-red-500"
                  }`}
                  id="role"
                  name="role"
                  required
                  value={role}
                  onChange={(e) => {
                    setRole(e.target.value);
                    setErrors((prevErrors) => ({ ...prevErrors, role: "" }));
                  }}
                >
                  <option value="">Select a role</option>
                  <option value="ADMIN">Admin</option>
                  <option value="MD">MD</option>
                  <option value="BOD">BOD</option>
                  <option value="TELECALLER">Telecaller</option>
                  <option value="MARKETING EXECUTIVE">
                    Marketing Executive
                  </option>
                  <option value="FIELD WORKER">Field Worker</option>
                  <option value="LEAD UPLOADER">Lead Uploader</option>
                  <option value="CMO">CMO</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 24 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                      fill="#399E79"
                    />
                  </svg>
                </div>
              </div>
            </div>
            {role && role !== "ADMIN" && role !== "LEAD UPLOADER" && role !== "CMO" && (
              <div className="mb-8 flex items-center">
                <label
                  className="w-1/4 text-gray-700 text-2xl font-medium"
                  htmlFor="teams"
                >
                  Teams <AsteriskStyle/>
                </label>
                <div className="w-3/4">
                  <Select
                    isMulti={role == "MD"}
                    // options={teams}
                    options={teams.filter(
                      (team) => role !== "MD" || !team?.MD?.name
                    )}
                    value={selectedTeam}
                    onChange={(selectedOptions) => {
                      setSelectedTeam(selectedOptions); // Update the selected team state
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        selectedTeam: "",
                      })); // Clear team selection errors
                    }}
                    placeholder="Select a team"
                    className={`${
                      errors.selectedTeam && "border border-red-500 rounded"
                    } shadow appearance-none w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                  />
                </div>
              </div>
            )}
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="emailId"
              >
                Email ID <AsteriskStyle/>
              </label>
              <input
                className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  emailError || (errors.emailId && "border-red-500")
                }`}
                id="emailId"
                type="text"
                placeholder={errors.emailId || "Enter Email ID"}
                required
                value={emailId}
                onChange={(e) => {
                  setEmailId(e.target.value.toLocaleLowerCase());
                  setErrors((prevErrors) => ({ ...prevErrors, emailId: "" }));
                }}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="employeeId"
              >
                Employee ID  <AsteriskStyle/>
              </label>
              <input
                className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.employeeId && "border-red-500"
                }`}
                id="employeeId"
                type="text"
                placeholder={errors.employeeId || "Enter Employee ID"}
                required
                maxLength={50}
                value={employeeId}
                onChange={(e) => {
                  setEmployeeId(e.target.value);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    employeeId: "",
                  }));
                }}
              />
            </div>
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="phoneNumber"
              >
                Phone Number <AsteriskStyle/>
              </label>
              <input
                className={`shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  phoneError || (errors.phoneNumber && "border-red-500")
                }`}
                id="phoneNumber"
                type="tel"
                pattern="[0-9]{10}"
                placeholder={
                  phoneNumberError
                    ? "Invalid phone number format"
                    : "Enter Phone Number"
                }
                required
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
              />
            </div>

            <h1 className="text-center font-light">
              *Note - Logging password will be sent to users Email ID
            </h1>
          </form>
      </div>
    </div>
  );
};

export default UserCreation;
